var _defs, _rect, _g, _g2, _g3, _rect2, _rect3, _polygon, _g4, _g5, _g6, _g7, _g8, _rect4, _g9, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexhnextyellowbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffca2b;\n      }\n\n      .cls-2 {\n        fill: #3c4693;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 216,
    height: 216
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H-left"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.31,
    y: 94.88,
    width: 3.24,
    height: 15.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "H-left-2",
    "data-name": "H-left"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 117.09,
    y: 94.88,
    width: 3.24,
    height: 15.09
  })), /*#__PURE__*/React.createElement("rect", {
    id: "H-bar",
    className: "cls-2",
    x: 111.86,
    y: 95.69,
    width: 2.91,
    height: 14.02,
    transform: "translate(216.01 -10.62) rotate(90)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.84,
    y: 101.38,
    width: 3.02,
    height: 14.02,
    transform: "translate(190.73 26.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.34,
    y: 95.81,
    width: 3,
    height: 14.08,
    transform: "translate(153.68 205.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.84,
    y: 95.34,
    width: 3.02,
    height: 14.02,
    transform: "translate(-20 184.7) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 140.98,
    y: 97.65,
    width: 3.02,
    height: 9.4,
    transform: "translate(40.14 244.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.63,
    y: 89.51,
    width: 3.43,
    height: 14.02,
    transform: "translate(-14.17 178.87) rotate(-90)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.75,
    y: 96.82,
    width: 3,
    height: 13.08,
    transform: "translate(134.51 206.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.93,
    y: 89.31,
    width: 3.02,
    height: 14.02,
    transform: "translate(-28.87 163.76) rotate(-90)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.95 94.81 74.45 96.32 72.95 97.82 72.95 94.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.93 97.82 60.43 96.32 61.93 94.81 61.93 97.82"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.44,
    y: 96.82,
    width: 3,
    height: 13.08,
    transform: "translate(349.88 206.71) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.61,
    y: 89.31,
    width: 3.02,
    height: 14.02,
    transform: "translate(78.81 271.44) rotate(-90)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.61 97.82 168.11 96.32 169.61 94.81 169.61 97.82"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-Bar",
    className: "cls-2",
    points: "92.47 109.89 90.36 107.77 103.43 94.88 105.55 97 92.47 109.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.45 107.77 103.32 109.89 90.36 96.93 92.48 94.81 105.45 107.77"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.45 107.77 105.44 109.89 103.33 109.89 105.45 107.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.36 96.93 90.36 94.81 92.48 94.81 90.36 96.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.48 109.89 90.36 109.89 90.36 107.77 92.48 109.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.43 94.88 105.55 94.88 105.55 97 103.43 94.88"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E-2",
    "data-name": "E"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.91,
    y: 101.38,
    width: 3.02,
    height: 14.02,
    transform: "translate(251.8 -35.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.41,
    y: 95.81,
    width: 3,
    height: 14.08,
    transform: "translate(275.82 205.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.7,
    y: 89.51,
    width: 3.43,
    height: 14.02,
    transform: "translate(46.89 239.94) rotate(-90)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "X-2",
    "data-name": "X"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-Bar-2",
    "data-name": "Base-Bar",
    className: "cls-2",
    points: "153.78 109.89 151.67 107.77 164.75 94.88 166.87 97 153.78 109.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.76 107.77 164.63 109.89 151.67 96.93 153.79 94.81 166.76 107.77"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.76 107.77 166.76 109.89 164.64 109.89 166.76 107.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.67 96.93 151.67 94.81 153.79 94.81 151.67 96.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "153.79 109.89 151.67 109.89 151.67 107.77 153.79 109.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "164.75 94.88 166.87 94.88 166.87 97 164.75 94.88"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "T-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.4,
    y: 94.88,
    width: 3,
    height: 15.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 121.38,
    y: 94.88,
    width: 3,
    height: 15.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.58 97.3 124.39 94.88 134.41 107.77 132.4 109.97 122.58 97.3"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.73,115.83l-.06,.64h-.94v.98c0,.2,.08,.26,.48,.26,.17,0,.37-.01,.45-.03h.07s.09,.61,.09,.61c-.21,.04-.42,.06-.64,.06-.75,0-1.12-.3-1.12-.91v-.98h-.42l.05-.64h.4l.22-.55,.42-.04v.59h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,118.33v-1.4c0-.09,0-.12-.04-.24-.05-.14-.22-.26-.61-.26-.24,0-.48,.04-.73,.14v1.76h-.67v-3.43l.67-.04v1.08c.29-.1,.56-.15,.78-.15,.8,0,1.28,.41,1.28,1.15v1.4h-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.43,117.38h-1.87c.12,.22,.36,.33,.73,.33,.26,0,.53-.04,.81-.14l.19,.6c-.27,.12-.61,.18-1.01,.18-.43,0-.79-.12-1.06-.35-.27-.23-.41-.54-.41-.93s.13-.69,.39-.93c.26-.23,.61-.35,1.04-.35,.34,0,.62,.1,.86,.32,.23,.21,.35,.5,.35,.87l-.02,.39Zm-1.9-.56h1.23c0-.25-.2-.38-.52-.38-.38,0-.62,.13-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.47,115.83l-.05,.64h-.95v1.87h-.68v-1.87h-.42l.05-.64h.36v-.05c0-.6,.37-.91,1.1-.91,.2,0,.45,.03,.57,.05h.09s-.09,.64-.09,.64c-.17-.04-.35-.05-.54-.05-.37,0-.45,.07-.45,.26v.05h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.28,115.81v1.4c0,.12,.01,.18,.08,.3,.08,.12,.27,.2,.58,.2,.24,0,.48-.04,.73-.14v-1.76h.67v2.53h-.59l-.03-.16c-.31,.12-.59,.17-.83,.17-.8,0-1.28-.41-1.28-1.15v-1.4h.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.57,115.83l-.06,.64h-.94v.98c0,.2,.08,.26,.48,.26,.17,0,.37-.01,.45-.03h.07s.09,.61,.09,.61c-.21,.04-.42,.06-.64,.06-.75,0-1.12-.3-1.12-.91v-.98h-.42l.05-.64h.4l.22-.55,.42-.04v.59h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.46,115.81v1.4c0,.12,.01,.18,.08,.3,.08,.12,.27,.2,.58,.2,.24,0,.48-.04,.73-.14v-1.76h.67v2.53h-.59l-.03-.16c-.31,.12-.59,.17-.83,.17-.8,0-1.28-.41-1.28-1.15v-1.4h.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.76,115.84h.06s-.16,.65-.16,.65c-.13-.04-.29-.06-.49-.06-.24,0-.48,.04-.72,.14v1.76h-.67v-2.47l.59-.03,.02,.14c.32-.12,.6-.18,.84-.18,.21,0,.43,.03,.52,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.44,117.38h-1.87c.12,.22,.36,.33,.73,.33,.26,0,.53-.04,.81-.14l.19,.6c-.27,.12-.61,.18-1.01,.18-.43,0-.79-.12-1.06-.35-.27-.23-.41-.54-.41-.93s.13-.69,.39-.93c.26-.23,.61-.35,1.04-.35,.34,0,.62,.1,.86,.32,.23,.21,.35,.5,.35,.87l-.02,.39Zm-1.9-.56h1.23c0-.25-.2-.38-.52-.38-.38,0-.62,.13-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.51,119.05v-4.87h.68v4.87h-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.18,115.87h.76v.35h-.77v1.3c0,.29,.09,.47,.39,.47,.11,0,.23-.03,.34-.09l.12,.34c-.17,.08-.31,.11-.48,.12-.53,0-.78-.3-.78-.84v-1.3h-.49v-.35h.49v-.68l.41-.04v.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.63,114.84v1.43c.21-.32,.54-.43,.85-.44,.69,0,1.03,.46,1.03,1.14v1.36h-.4v-1.35c0-.48-.25-.76-.7-.76s-.78,.35-.78,.8v1.31h-.41v-3.49h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.18,117.94c-.25,.29-.68,.44-1.06,.44-.76,0-1.3-.5-1.3-1.29s.53-1.28,1.28-1.28,1.33,.46,1.23,1.45h-2.1c.04,.45,.42,.74,.89,.74,.28,0,.62-.11,.78-.31l.27,.25h0Zm-.24-1.02c-.02-.48-.35-.74-.83-.74-.43,0-.8,.26-.87,.73h1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.68,115.88h.39l.02,.47c.19-.33,.56-.52,.95-.52,.71,.01,1.23,.51,1.23,1.27s-.51,1.28-1.25,1.28c-.35,0-.74-.15-.93-.5v1.61h-.4v-3.62Zm2.18,1.24c0-.55-.36-.88-.87-.88s-.86,.38-.86,.88,.36,.88,.86,.89c.49,0,.87-.33,.87-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134,115.86l.03,.37c.17-.32,.47-.41,.76-.41,.21,0,.42,.07,.57,.18l-.18,.35c-.13-.09-.26-.13-.43-.13-.39,0-.72,.29-.72,.74v1.37h-.41v-2.46h.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.71,117.94c-.25,.29-.68,.44-1.06,.44-.76,0-1.3-.5-1.3-1.29s.53-1.28,1.28-1.28,1.33,.46,1.23,1.45h-2.1c.04,.45,.42,.74,.89,.74,.28,0,.62-.11,.78-.31l.27,.25h0Zm-.24-1.02c-.02-.48-.35-.74-.83-.74-.43,0-.8,.26-.87,.73h1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.76,116.42c-.21-.2-.44-.24-.69-.24-.34,0-.61,.11-.61,.36,0,.25,.3,.33,.61,.36,.45,.06,1.05,.15,1.04,.75-.01,.49-.48,.74-1.03,.74-.41,0-.82-.11-1.1-.46l.23-.28c.22,.27,.57,.38,.88,.38,.27,0,.61-.08,.62-.38,0-.27-.28-.35-.66-.39-.47-.06-.98-.18-.98-.71,0-.52,.52-.73,1-.72,.37,0,.67,.09,.94,.33l-.23,.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.62,117.94c-.25,.29-.68,.44-1.06,.44-.76,0-1.3-.5-1.3-1.29s.53-1.28,1.28-1.28,1.33,.46,1.23,1.45h-2.1c.04,.45,.42,.74,.89,.74,.28,0,.62-.11,.78-.31l.27,.25h0Zm-.24-1.02c-.02-.48-.35-.74-.83-.74-.43,0-.8,.26-.87,.73h1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.09,115.86h.37l.02,.39c.21-.29,.51-.43,.84-.43,.62,0,1.08,.42,1.08,1.14v1.36h-.41v-1.36c0-.47-.28-.77-.75-.77-.45,0-.76,.36-.76,.8v1.32h-.4v-2.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.57,115.87h.76v.35h-.77v1.3c0,.29,.09,.47,.39,.47,.11,0,.23-.03,.34-.09l.12,.34c-.17,.08-.31,.11-.48,.12-.53,0-.78-.3-.78-.84v-1.3h-.49v-.35h.49v-.68l.41-.04v.72Z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.87,
    y: 95.82,
    width: 4.29,
    height: 14.19,
    transform: "translate(72.02 205.83) rotate(180)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "X-3",
    "data-name": "X"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-Bar-3",
    "data-name": "Base-Bar",
    className: "cls-2",
    points: "50.1 109.99 47.53 107.41 55.24 99.92 57.82 102.49 50.1 109.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.74 102.41 54.93 105.21 47.34 97.6 50.13 94.81 57.74 102.41"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.99 96.94 47.99 94.8 50.13 94.8 47.99 96.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.13 110.01 47.99 110.01 47.99 107.87 50.13 110.01"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.68,
    y: 98.58,
    width: 2.61,
    height: 8.12,
    transform: "translate(-50.66 154.62) rotate(-90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.41,
    y: 101.42,
    width: 3.04,
    height: 14.13,
    transform: "translate(149.42 67.56) rotate(90)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.2,
    y: 89.47,
    width: 3.46,
    height: 14.13,
    transform: "translate(-55.6 137.47) rotate(-90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexhnextyellowbg);
export default __webpack_public_path__ + "static/media/Texhnextyellowbg.610fe5eb55ed241a24e9eadd7960d5ae.svg";
export { ForwardRef as ReactComponent };